import { render, staticRenderFns } from "./AIHistory.vue?vue&type=template&id=a8b3c660&"
import script from "./AIHistory.vue?vue&type=script&lang=js&"
export * from "./AIHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports